import React from "react";
import useOTPVerification from "./useOTPVerification";
import OTPLogo from "../../assets/otp_screen_logo.png";
import bgImage from "../../assets/bg-image.jpg";

const OTPConfirmationPage = () => {
  const { handleSubmit, handleChange, handleKeyUp, otp, otpInputs } =
    useOTPVerification();
  return (
    <div
      className="flex flex-col h-screen"
      style={{ backgroundImage: `url(${bgImage})`, backgroundSize: "cover" }}
    >
      <div className="absolute inset-0 bg-cyan-950 opacity-90"></div>
      <div className="flex h-20 bg-white mt-3 z-20 items-center px-10">
        <img
          src="https://nxgcreator.s3.ap-south-1.amazonaws.com/ayurGroup%20512.png"
          alt="logo"
          style={{ width: "60px", height: "60px" }}
        />
        <span className="text-xl font-bold ml-2"> Ayur Guide</span>
      </div>
      <div className=" flex items-center justify-center  z-10 h-screen h-[calc(100vh - 100px)]">
        <div className="flex  gap-20 p-20 rounded bg-white">
          <img src={OTPLogo} alt="otp-logo" className="h-52" />
          <div className="flex flex-col gap-5" style={{ width: "400px" }}>
            <span className=" text-2xl font-semibold mb-1">
              OTP Verification
            </span>
            <span className="text-gray-500">
              Enter the verification code we just sent you on your mobile phone.
            </span>
            <div className="flex flex-row gap-1">
              <form onSubmit={handleSubmit}>
                <div className="flex justify-between gap-3 mb-4">
                  {[0, 1, 2, 3].map((index) => (
                    <input
                      key={index}
                      ref={(el) => (otpInputs.current[index] = el)}
                      type="text"
                      maxLength="1"
                      value={otp[index]}
                      onChange={(e) => handleChange(index, e)}
                      onKeyUp={(e) => handleKeyUp(index, e)}
                      className="shadow appearance-none text-center border rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline"
                    />
                  ))}
                </div>
                <div className="flex items-center justify-center w-full">
                  <button
                    type="submit"
                    className="bg-emerald-500 mb-3 uppercase hover:bg-emerald-600 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                  >
                    Verify OTP
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OTPConfirmationPage;
